import React from 'react';
import { Card, CardContent } from '../../../../components/ui/Card';
import { cn } from '../../../../utils/cn';

interface LoadingCardProps {
  height?: string;
}

const LoadingCard: React.FC<LoadingCardProps> = ({ height = 'h-[120px]' }) => {
  return (
    <Card>
      <CardContent className={cn('flex items-center justify-center', height)}>
        <div className="w-6 h-6 border-2 border-muted border-t-primary rounded-full animate-spin" />
      </CardContent>
    </Card>
  );
};

export default LoadingCard;
